export default "<p>precificacao-list works!</p>\n";